<template>
  <div style="inline-block;">
    <el-select v-model="areaData.provinceId" class="area-item" placeholder="省份" clearable @change="onProviceChanged" >
      <el-option
        v-for="item in provinceList"
        :key="item.provinceCode"
        :label="item.provinceName"
        :value="item.provinceId" />
    </el-select>
    <el-select v-model="areaData.cityId" class="area-item" placeholder="城市" clearable @change="onCityChanged">
      <el-option
        v-for="item in cityList"
        :key="item.cityCode"
        :label="item.cityName"
        :value="item.cityId" />
    </el-select>
    <el-select v-model="areaData.countyId" class="area-item" placeholder="区县" clearable @change="onCountyChanged">
      <el-option
        v-for="item in countyList"
        :key="item.countyCode"
        :label="item.countyName"
        :value="item.countyId" />
    </el-select>
  </div>
</template>

<script>
import baseApi from '@/api/base'
export default {
  name: 'AreaSelector',
  props: {
    value: {
      type: Object,
      default() {
        return {
          provinceId: '',
          cityId: '',
          countyId: ''
        }
      }
    }
  },
  data() {
    return {
      areaData: this.value,
      provinceList: [],
      cityList: [],
      countyList: []
    }
  },
  watch: {
    value: function (newVal) {
      // console.log('watch area data')
      // console.log(newVal)
      // console.log(oldVal)
      this.queryCityList(newVal.provinceId).then(() => {
        return this.queryCountyList(newVal.cityId)
      }).then(() => {
        this.areaData = newVal
      })
    }
  },
  created() {
    this.queryProvinceList()
    this.init()
  },
  methods: {
    init() {
      // console.log('init')
      // console.log(this.areaData)
      this.areaData.provinceId = this.value.provinceId
      this.queryProvinceList().then(() => {
        return this.queryCityList(this.value.provinceId)
      }).then(() => {
        return this.queryCountyList(this.value.cityId)
      }).then(() => {
        this.areaData.cityId = this.value.cityId
        this.areaData.countyId = this.value.countyId
      })
    },
    queryProvinceList() {
      return new Promise((resolve, reject) => {
        baseApi.queryProvince().then(response => {
          this.provinceList = response.data.resultData.provinceList || []
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    queryCityList(provinceId) {
      return new Promise((resolve, reject) => {
        if (provinceId) {
          baseApi.queryCity({ provinceId: provinceId }).then(response => {
            this.cityList = response.data.resultData.cityList || []
            resolve()
          }).catch(error => {
            reject(error)
          })
        } else {
          resolve()
        }
      })
    },
    queryCountyList(cityId) {
      return new Promise((resolve, reject) => {
        if (cityId) {
          baseApi.queryCounty({ cityId: cityId }).then(response => {
            this.countyList = response.data.resultData.countyList || []
            resolve()
          }).catch(error => {
            reject(error)
          })
        } else {
          resolve()
        }
      })
    },

    onProviceChanged(val) {
      this.cityList = []
      this.countyList = []
      this.areaData.cityId = ''
      this.areaData.countyId = ''
      if (!val) {
        return
      }
      this.queryCityList(val)
      this.$emit('input', this.areaData)
    },
    onCityChanged(val) {
      this.countyList = []
      this.areaData.countyId = ''
      if (!val) {
        return
      }
      this.queryCountyList(val)
      this.$emit('input', this.areaData)
    },
    onCountyChanged() {
      this.$emit('input', this.areaData)
    }
  }
}
</script>

<style lang="scss" scoped>
.area-item {
  width: 120px;
}
.area-item+.area-item {
  margin-left: 15px;
}
</style>
